import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

const propTypes = {
  count: PropTypes.number,
};

const defaultProps = {
  count: 0,
};

const Header = ({ count }) => {
  const subheader = (
    <span className="margin-left-20 text-size-14 text-weight-book">{count} { pluralize('Past Parking Session', count) }</span>
  );

  return (
    <div>
      <h2 className="text-color-dark-slate margin-vertical-10 text-size-20 text-weight-bold">
        WHERE YOU&#39;VE BEEN
        { count ? subheader : null }
      </h2>
    </div>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
